<template>
  <div class="page">
    <div class="section">
      <Button @click="onShowDomainList" shape="circle"
        >从我的域名列表选择域名</Button
      >
      <Form label-position="top" style="margin-top: 40px">
        <FormItem
          class="cc-form-item"
          :label="'您要转移的域名（' + dnNumber + '）'"
          required
        >
          <Input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 500 }"
            v-model="form.domain"
            @on-keyup="getDNNumber"
            @on-blur="getAvailableDN"
            placeholder="每行一个域名，最多100个"
            style="width: 500px"
            clearable
          ></Input>
        </FormItem>
        <FormItem class="cc-form-item" label="对方的ID" required>
          <template>
            <div class="row">
              <Input
                class="height60"
                v-model.trim="form.toUserId"
                @on-blur="searchIdentity"
                placeholder="请填写正确的会员ID"
                style="width: 360px"
                clearable
              ></Input>
              <div class="row" v-if="result">
                <img
                  class="check-icon"
                  src="@/assets/image/success-icon.png"
                />{{ resultText }}
              </div>
              <div class="row" v-else-if="!result && resultText">
                <img class="check-icon" src="@/assets/image/fail-icon.png" />{{
                  resultText
                }}
              </div>
            </div>
          </template>
        </FormItem>
        <FormItem class="cc-form-item" label="对方账户邮箱">
          <template>
            <div class="row">
              <Input
                class="height60"
                v-model.trim="form.email"
                placeholder="请填写正确的对方账户邮箱"
                style="width: 360px"
                clearable
              ></Input>
              <div style="margin-left: 30px">选填</div>
            </div>
          </template>
        </FormItem>
        <FormItem class="cc-form-item" label="索要金额">
          <template>
            <div class="row">
              <Input
                class="height60"
                v-model.trim="form.money"
                placeholder="请填写索要金额"
                style="width: 360px"
                clearable
                @on-keyup="form.money = form.money.replace(/[^\d^\.]+/g, '')"
              ></Input>
              <div style="margin-left: 30px">
                元 为保证域名安全，请索要相应金额
              </div>
            </div>
          </template>
        </FormItem>
        <FormItem class="cc-form-item" label="附言备注">
          <template>
            <div class="row">
              <Input
                class="height60"
                v-model.trim="form.notes"
                placeholder="附言备注"
                style="width: 360px"
                clearable
              ></Input>
              <div style="margin-left: 30px">选填</div>
            </div>
          </template>
        </FormItem>
        <FormItem class="cc-form-item" label="60天内禁止转移注册商锁定">
          <div class="row" style="line-height: 32px">
            <RadioGroup v-model="form.isLock">
              <Radio :label="0"> 不设置</Radio>
              <Radio :label="1"> 设置</Radio>
            </RadioGroup>
          </div>
        </FormItem>
        <div v-if="checkType === 0" class="u-col">
          <FormItem class="cc-form-item" label="手机号码">
            <template>
              <div class="row">
                <Input
                  class="height60"
                  v-model.trim="user.mobile"
                  placeholder="手机号码"
                  style="width: 360px"
                  disabled
                  clearable
                ></Input>
                <div v-if="user.email && user.email.length > 0" style="margin-left: 20px; height: 60px; line-height: 60px">
                  <Button @click="checkType=1" :disabled="codeDisabled" type="text">邮箱验证</Button>
                </div>
              </div>
            </template>
          </FormItem>
        </div>
        <div v-if="checkType === 1" class="u-col">
          <FormItem class="cc-form-item" label="邮箱">
            <template>
              <div class="row">
                <Input
                  class="height60"
                  v-model.trim="user.email"
                  placeholder="邮箱"
                  style="width: 360px"
                  disabled
                  clearable
                ></Input>
                <div v-if="user.mobile && user.mobile.length > 0" style="margin-left: 20px; height: 60px; line-height: 60px">
                  <Button @click="checkType=0" :disabled="codeDisabled" type="text">手机号码验证</Button>
                </div>
              </div>
            </template>
          </FormItem>
        </div>
        <FormItem class="cc-form-item" label="验证码">
          <template>
            <div class="row">
              <Input
                class="height60"
                v-model.trim="form.vCode"
                placeholder="请填写验证码"
                style="width: 120px"
                clearable
              ></Input>
              <div style="margin-left: 30px; height: 60px">
                <identify
                  :identify-code="identifyCode"
                  :content-height="60"
                  @reloadEvent="reloadCodeEvent"
                />
              </div>
            </div>
          </template>
        </FormItem>
        <FormItem class="cc-form-item" :label="checkType==0 ? '短信验证码' : '邮箱验证码'" required>
          <template>
            <div class="row">
              <Input
                class="height60"
                v-model.trim="form.code"
                placeholder="请填写验证码"
                style="width: 360px"
                clearable
                @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
              ></Input>
              <smsBtn
                ref="smsBtn"
                height="60px"
                shape=""
                @tap="getCodeEvent"
                style="width: 120px; margin-left: 30px"
              ></smsBtn>
            </div>
          </template>
        </FormItem>
      </Form>
      <div class="row">
        <Checkbox v-model="single"> 我已同意并阅读</Checkbox>
        <span style="color: #1c9cdf; cursor: pointer" @click="pushModel"
          >《域名管理系统域名push服务协议》</span
        >
      </div>
      <div style="margin-top: 40px">
        <Button
          :loading="loading"
          type="primary"
          style="margin-right: 20px; height: 60px; width: 120px"
          @click="submit()"
          >提交PUSH</Button
        >
      </div>
    </div>
    <!-- 选择域名 -->
    <domainListModal
      :show.sync="domainListModalVisibility"
      :checkedDomain="checkedDomain"
      @onChecked="onChecked"
    ></domainListModal>
    <!-- PUSH结果 -->
    <pushListModal
      :show.sync="pushListModalVisibility"
      :data="resultList"
    ></pushListModal>
    <!-- 域名管理系统域名push服务协议 -->
    <rule-modal
      :show.sync="pushRulesModelShow"
      :content="pushRulesContent"
      :title="pushRulesTitle"
    ></rule-modal>
  </div>
</template>
<script>
import smsBtn from "components/smsBtn.vue";
import { makeCode } from "utils/identify";
import identify from "components/identify.vue";
import domainListModal from "components/domain/domainListModal.vue";
import pushListModal from "components/push/pushListModal.vue";
import { debounce, trimStr } from "utils/index";
import { userCheck, pushCreate } from "api/domain.js";
import { smsSend } from "api/customer.js";
import { mapMutations, mapState } from "vuex";
import ruleModal from "components/ruleModal.vue";
import pushRules from "assets/rule/pushRules";
export default {
  name: "push",
  components: {
    domainListModal,
    pushListModal,
    identify,
    smsBtn,
    ruleModal,
  },
  data() {
    return {
      identifyCode: "",
      domainListModalVisibility: false,
      pushListModalVisibility: false,
      resultList: [],
      checkedDomain: [],
      dnNumber: 0,
      noReq: false,
      result: false,
      resultText: "",
      single: false,
      form: {
        domain: "",
        email: "",
        isLock: 0,
        code: "",
        money: "",
        notes: "",
        toUserId: "",
        vCode: "",
      },
      loading: false,
      // 域名管理系统域名push服务协议
      pushRulesModelShow: false,
      pushRulesContent: "",
      pushRulesTitle: "",
      checkType: 0,
      codeDisabled: false
    };
  },
  computed: {
    ...mapState(["routeParamsList", "user"]),
  },
  created() {
    this.identifyCode = makeCode();
    if (this.routeParamsList.length > 0) {
      this.checkedDomain = this.routeParamsList;
      const domainStr = this.routeParamsList.join("\n");
      this.form.domain = domainStr;
      this.dnNumber = this.routeParamsList.length;
    }
    setTimeout(() => {
      if (this.user.mobile != null && this.user.mobile.length > 0) {
        this.checkType = 0
      } else {
        this.checkType = 1
      }
    }, 300)
  },
  beforeDestroy() {
    // 传递参数
    this.MTU_ROUTE_PARAMS_LIST([]);
  },
  methods: {
    ...mapMutations(["MTU_ROUTE_PARAMS_LIST"]),
    // 协议
    pushModel() {
      this.pushRulesModelShow = true;
      if (!this.pushRulesContent) {
        this.pushRulesContent = pushRules.content;
        this.pushRulesTitle = pushRules.title;
      }
    },
    // 打开选择域名
    onShowDomainList() {
      this.domainListModalVisibility = true;
    },
    // 选中域名
    onChecked(val) {
      this.checkedDomain = val;
      const domainStr = val.join("\n");
      this.form.domain = domainStr;
      this.dnNumber = val.length;
    },
    // 函数防抖获取输入框中的域名
    getDNNumber: debounce(function () {
      const temp = this.form.domain.split("\n");
      this.dnNumber = temp.filter((item) => {
        return !item.match(/^[ ]*$/);
      }).length;
    }, 200),
    // 筛选出有用域名
    getAvailableDN() {
      const temp = this.form.domain.split("\n").filter((item) => {
        return !item.match(/^[ ]*$/);
      });
      const dnList = temp.map((item) => trimStr(item));
      this.dnSet = new Set(dnList);
      this.checkedDomain = [...this.dnSet];
      this.form.domain = [...this.dnSet].join("\n");
      this.dnNumber = this.dnSet.size;
    },
    // 搜索ID是否存在
    async searchIdentity() {
      if (!this.form.toUserId) {
        return false;
      }
      this.loading = true;
      const { code, data } = await userCheck({ uName: this.form.toUserId });
      this.loading = false;
      if (code === 200) {
        this.result = data.exist;
        if (data.exist) {
          this.resultText = data.username;
        } else {
          this.resultText = "账户ID不存在";
        }
      }
    },
    // 刷新图形验证码
    reloadCodeEvent() {
      this.identifyCode = makeCode();
    },
    // 获取验证码
    getCodeEvent(callback) {
      if (!this.form.vCode) {
        this.$Message.warning("请输入验证码！");
        this.$refs.smsBtn.reset();
        return false;
      }
      if (this.form.vCode.toLowerCase() !== this.identifyCode.toLowerCase()) {
        this.$Message.warning("请输入正确验证码！");
        return false;
      }
      smsSend(this.checkType)
        .then((res) => {
          if (res.code === 200 && res.result) {
            this.codeDisabled = true;
            callback(true);
          }
        })
        .catch(() => {
          this.codeDisabled = false;
          this.$refs.smsBtn.reset();
        });
    },
    async submit() {
      if (!this.form.domain) {
        this.$Message.warning("请输入要push的域名");
        return false;
      }
      if (!this.result) {
        this.$Message.warning("请输入有效的ID");
        return false;
      }
      if (!this.form.money) {
        this.$Message.warning("请输入索要金额");
        return false;
      }
      if (!this.form.vCode) {
        this.$code.warning("请输入验证码");
        return false;
      }
      if (!this.form.code) {
        this.$code.warning("请输入短信验证码");
        return false;
      }
      if (!this.single) {
        this.$Message.warning("请阅读协议并同意push协议");
        return false;
      }
      let params = {
        amount: this.form.money,
        dnSet: this.form.domain.split("\n"),
        isLock: this.form.isLock,
        msgCode: this.form.code,
        user: this.form.toUserId,
        remark: this.form.notes,
        opEmail: this.form.email,
        type: this.checkType
      };
      try {
        this.loading = true;
        const { code, data } = await pushCreate(params);
        this.loading = false;
        if (code === 200) {
          if (data.length > 0) {
            // 显示失败得域名
            this.reslutList = data;
            this.pushListModalVisibility = true;
          } else {
            this.$Message.success("操作成功！");
            this.form = this.$options.data().form;
            this.result = false;
            this.resultText = "";
            this.single = false;
            this.identifyCode = makeCode();
          }
        }
        this.codeDisabled = false;
        this.$refs.smsBtn.reset();
      } catch (error) {
        this.loading = false;
        this.codeDisabled = false;
        this.$refs.smsBtn.reset();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.section {
  padding: 40px 60px;
  background-color: #fff;
  .check-icon {
    width: 16px;
    height: 16px;
    margin-right: 10px;
    margin-left: 30px;
  }
}
.row {
  display: flex;
  align-items: center;
}
/deep/.cc-form-item {
  .ivu-form-item-label {
    padding-bottom: 20px;
  }
}
/deep/.height60 {
  .ivu-input {
    height: 60px;
    line-height: 60px;
  }
  .ivu-input-icon {
    line-height: 60px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 60px;
  }
  .ivu-select-input {
    height: 60px;
  }
  .ivu-select-selected-value {
    height: 60px;
    line-height: 60px;
  }
  .ivu-select-placeholder {
    height: 60px;
    line-height: 60px;
  }
}
</style>
